<template>
<div style="height:100%;">
  <div style="background:#fff;padding:0 24px 24px;height:100%;">
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="部门文件">
        <dep-list />
      </a-tab-pane>
      <a-tab-pane key="2" tab="链接分享文件" force-render>
        <link-list/>
      </a-tab-pane>
    </a-tabs>
  </div>
</div>
</template>
<script>
import DepList from './DepShare/DepList.vue'
import LinkList from './List.vue'
export default {
  components: {
    DepList, LinkList
  },
  data(){
    return{

    }
  },
  methods: {
    callback(key) {
      console.log(key);
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .ant-tabs-tab {
    line-height: 22px!important;
  }
  ::v-deep .ant-tabs-bar .ant-tabs-nav {
    height: 40px!important;
  }
  ::v-deep .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab {
    height: 40px!important;
    margin-right: 60px!important;
    color: #777;
  }
  ::v-deep .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab-active {
    color: #222!important;
  }
  ::v-deep .ant-tabs-bar {
    // border-bottom: 1px solid #E8ECF1;
    margin-bottom: 12px!important;
    padding-top:20px;
  }
</style>
